import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import photo from '../assets/HeadBack.webp';
import Blogs from '../data/Blogs.json';
import PageBanner from './SectionPageBanner';



const Project = () => {
  const navigate = useNavigate();

  const handleReadMore = (id) => {
    navigate(`/blogs/${id}`);
  };

  return (
    <Box sx={{ pb: 5, textAlign: 'center' }}>
      <PageBanner image={photo} title="Blogs" />
      <Box
        sx={{
          mx: 'auto',
          width: {
            xs: '95%',
            sm: '100%',
            md: '100%',
            lg: '85%',
            xl: '85%',
          },
          fontFamily: 'Nunito, sans-serif',
        }}
        maxWidth="lg"
      >
        <Box component="section" className="articles" sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '24px',
          maxWidth: '1200px',
          margin: 'auto',
          padding: '24px',
        }}>
          {Blogs.map((blog) => (
            <Box
              component="article"
              key={blog.id}
              sx={{
                borderRadius: '16px',
                backgroundColor: '#fff',
                overflow: 'hidden',
                transition: 'all 0.4s ease-in-out',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                '&:hover': {
                  boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
                  '& img': {
                    transform: 'scale(1.1)',
                  },
                  '& h2': {
                    color: '#28666e',
                  },
                  '& svg': {
                    transform: 'translateX(0)',
                    opacity: 1,
                  }
                }
              }}
            >
              <Box
                component="figure"
                sx={{
                  m: 0,
                  p: 0,
                  aspectRatio: '16 / 9',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={`/photos/${blog.image}`}
                  alt={blog.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.4s ease-in-out',
                    transform: 'scale(1.001)',
                  }}
                />
              </Box>
              <Box
                className="article-body"
                sx={{
                  p: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                }}
              >
                <Typography
                  // variant="body2"
                  sx={{
                    fontFamily: 'Rajdhani, sans-serif',
                    fontSize:'16px',
                    fontWeight: 600,
                    mb: 2,
                    flexGrow: 1,
                  }}
                >
                  {blog.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: 'Nunito, sans-serif',
                    mb: 2,
                  }}
                >
                  {blog.description}
                </Typography>

                <Button
                  onClick={() => handleReadMore(blog.id)}
                  sx={{
                    fontFamily: 'Nunito, sans-serif',
                    p: 0,
                    textTransform: 'none',
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: '#28666e',
                    fontWeight: 500,
                    mt: 'auto',
                    mb: '10px',
                    '&:hover svg': {
                      transform: 'translateX(0)',
                      opacity: 1,
                    },
                  }}
                >
                  Read more
                  <span className="sr-only" style={{
                    position: 'absolute',
                    clip: 'rect(0 0 0 0)',
                    clipPath: 'inset(50%)',
                    height: 1,
                    width: 1,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                  }}>
                    about {blog.title}
                  </span>
                </Button>

              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Project;
